import { render, staticRenderFns } from "./Firebase.vue?vue&type=template&id=7a4fc9d8&"
import script from "./Firebase.vue?vue&type=script&lang=js&"
export * from "./Firebase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Ramon/PROYECTOS/JuanGabriel_POS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a4fc9d8')) {
      api.createRecord('7a4fc9d8', component.options)
    } else {
      api.reload('7a4fc9d8', component.options)
    }
    module.hot.accept("./Firebase.vue?vue&type=template&id=7a4fc9d8&", function () {
      api.rerender('7a4fc9d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/admin/settings/Firebase.vue"
export default component.exports